import { render, staticRenderFns } from "./campusClassTarget.vue?vue&type=template&id=4d97066e&"
import script from "./campusClassTarget.vue?vue&type=script&lang=js&"
export * from "./campusClassTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports